import PermissionBlock from './BasicPermissionBlock';
import PermissionSimpleBlock from './BasicPermissionSimpleBlock';

export const BasicPermissionBlock = PermissionBlock;
export const BasicPermissionSimpleBlock = PermissionSimpleBlock;
